import React, {Component} from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import Button from '@adsk/bim360-matrix-react-button';
import ModalConfirmation from '@adsk/bim360-matrix-react-modal-confirmation';

export default class NoPermissionsModal extends Component {
  onConfirm() {
    // we're clearing the browser url from any query params and then reloading
    window.history.replaceState({}, '', `${window.location.href.split('?')[0]}`);
    window.location.reload();
  }
  render() {
    const {hasViolation, hasGrowled, container} = this.props;
    if (!hasViolation || hasGrowled) {
      return null;
    }

    return (
      <ModalConfirmation
        container={container}
        onConfirm={this.onConfirm}
        title={i18n.t('permissionsErrors.modalHeader')}
        message={i18n.t('permissionsErrors.modalMessage')}
        confirmationButtonLabel={i18n.t('permissionsErrors.modalConfirmation')}
        confirmationButtonStyleType={Button.StyleType.PRIMARY}
        noCancelButton
        disableModalExit
      />
    );
  }
}

NoPermissionsModal.displayName = 'NoPermissionsModal';

NoPermissionsModal.propTypes = {
  container: PropTypes.object.isRequired,
  hasViolation: PropTypes.bool.isRequired,
  hasGrowled: PropTypes.bool.isRequired
};
